import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { HeartHandshake, LogOut } from "lucide-react";

export default function Header({ subtitle }) {
  const { user, logout } = useAuth();
  const initials = user?.name?.split(" ").map((n) => n[0]).slice(0, 2).join("") || "";
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#1e3a8a]">
            <HeartHandshake className="h-5 w-5 text-white" />
          </div>
          <div>
            <span className="font-display text-lg font-bold leading-none text-slate-900">Dual Care</span>
            <p className="text-xs text-slate-500">{subtitle}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="hidden text-right sm:block">
            <p className="text-sm font-semibold text-slate-800" data-testid="header-user-name">{user?.name}</p>
            <p className="text-xs capitalize text-slate-500">{user?.role?.replace("_", " ")}</p>
          </div>
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0d9488] text-sm font-semibold text-white">
            {initials}
          </div>
          <Button variant="ghost" size="icon" onClick={logout} data-testid="logout-btn" title="Sign out">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}
